module.exports = __webpack_public_path__ + "static/CVS_pin-952dcdea988683c38cb1370d35b32910.png";